import styled from "styled-components";
import { CTA } from "../components/CTA";
import { FeatureSection } from "../components/FeatureSection";
import { FeaturesIntro } from "../components/FeaturesIntro";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import { Nav } from "../components/Nav";
import { Pricing } from "../components/Pricing";
import { StoryStrip } from "../components/StoryStrip";
import { UseCases } from "../components/UseCases";
import { FEATURES } from "../constants/features";
import { black } from "../styles/colors";

export function Home() {
  return (
    <Page>
      <Nav />
      <Hero />
      <StoryStrip />
      <FeaturesIntro />
      {FEATURES.map((feature) => (
        <FeatureSection key={feature.id} feature={feature} />
      ))}
      <UseCases />
      <HowItWorks />
      <Pricing />
      <CTA />
      <Footer />
    </Page>
  );
}

const Page = styled.main({
  color: black,
  background: "#FDFDFD",
});
